module.exports = __webpack_public_path__ + "static/media/add.4177e95a.svg";